export default function () {
	const accordions = document.querySelectorAll('[data-plugin-accordion]');

	const animationTime = 300;
	const classes = {
		current: 'mate-accordion__panel--current'
	}
	const selectors = {
		content: '.mate-accordion__panel-content',
		current: '.mate-accordion__panel--current',
		trigger: '.mate-accordion__panel-title'
	}

	accordions.forEach(container => {
		
		// jQuery
		$(container).on('click', selectors.trigger, function () {
			const current = $(this);
			console.log(current);
			const accordionPanel = $(this).parent();
			if (accordionPanel.hasClass(classes.current)) {
				$('.mate-accordion__panel--current .button').text('More about this Deal')
				accordionPanel.removeClass(classes.current).find(selectors.content).slideUp(animationTime);
			} else {
				const current = $(container).parent().find(selectors.current);
				if (current.length > 0) {
					$('.mate-accordion__panel--current .button').text('More about this Deal')
					current.removeClass(classes.current).find(selectors.content).slideUp(animationTime);
				}
				accordionPanel.addClass(classes.current).find(selectors.content).slideDown(animationTime);
				$(`.mate-accordion__panel--current .button`).text('Less about this Deal')
			}
		});
	});
	// const { container, selectors, classes, animationTime } = this.options;
	
};